const Login = `package spacelift

# 🦕 Feel free to remove commented code once your policy is ready. 🦕
#
# Login policies can allow users to log in to the account, and optionally give
# them admin privileges, too. They affect all users in the account except for
# GitHub organization admins and private account owners.
#
# As input, login policies receive a JSON document like this:
#
# {
#   "request": {
#     "remote_ip": "string",
#     "timestamp_ns": "number - current Unix timestamp in nanoseconds"
#   },
#   "session": {
#     "login": "string",
#     "member": "boolean - is the user a member of the GitHub account",
#     "name": "string",
#     "teams": ["string"]
#   }
# }
#
# Based on this input, the policy may define boolean "allow", "admin" and "deny"
# rules. Positive outcome of at least one "deny" rule blocks the user from
# logging in to the account, no matter what the result of other rules is. Positive
# outcome of at least one "allow" rule allows the user to log in, while positive
# outcome of at least one "admin" gives them admin access on top of that, too.
# Note that "admin" automatically implies being able to log in, so you don't
# need to define a separate "allow" rule for that.
#
# ⚠️ In practice, any time you define an "allow" or "admin" rule, you should
# probably think of restricting access using a "deny" rule - most likely by
# disabling all non-members of the org - perhaps with a few exceptions:
#
# deny if {
#   whitelist := {"luke", "leia", "yoda"}
#
#   not input.session.member
#   not whitelist contains input.session.login
# }
#
# Here's a few things you can do with login policies:
#
# 1) Give members of the DevOps team admin access to Spacelift, and read access
# to everyone else in the organization:
# admin if {
#   input.session.teams[_] == "DevOps"
# }
#
# allow if {
#   input.session.member
# }
#
# 2) Allow a bunch of external contributors to get non-admin access to your
# account:
# allow if {
#   collaborators := {"alice", "bob", "charlene"}
#
#   collaborators contains input.session.login
# }
#
# 3) Only allow folks to log in on weekdays:
# deny if {
#   today   := time.weekday(input.request.timestamp_ns)
#   weekend := {"Saturday", "Sunday"}
#
#   weekend contains today
# }
#
# 4) Allow organization members, iff they're logging in from the office:
# allow if {
#   input.session.member
# }
#
# deny if {
#   office := "12.34.56.0/24"
#
#   not net.cidr_contains(office, input.request.remote_ip)
# }
#
# Now go ahead and unleash your inner lawgiver. For more information on the rule
# language, please visit https://www.openpolicyagent.org/docs/latest/
#
# NOTE:
# We prepend some boilerplate code to the policy to ensure that the outputs
# are defined. You can't change the type of our predefined rules (e.g. admin,
# allow, deny_admin, deny, flag, sample, space_admin, space_read, space_write,
# team) or you'll run into conflicting rule errors.
# For a detailed example and further explanation, refer to our documentation:
# https://docs.spacelift.io/concepts/policy#policy-structure
`;
export default Login;
